import { ReactNode } from 'react';
import { mediaNotReadyTooltip, transcriptionNotReadyTooltip } from '../fragment-view-tab-messages';
import { useFragment } from '../hooks/useFragment';
import { FragmentDisabledTabContent } from './FragmentDisabledTabContent';

export type FragmentTabRequirement = 'media' | 'transcription';

interface FragmentTabAccessGuardProps {
  /** Resource that must be ready for the tab content to render. */
  requirement: FragmentTabRequirement;
  children: ReactNode;
}

/**
 * Gates fragment tab content behind media or transcription readiness.
 * Matches the disabled state of tabs in {@link useFragmentTabs} so deep links
 * show the same waiting message instead of a broken or empty view.
 */
export function FragmentTabAccessGuard({ requirement, children }: FragmentTabAccessGuardProps) {
  const { fragment } = useFragment();

  const isMediaReady = !!fragment.mediaCompletedAt;
  const isTranscriptionReady = fragment.transcriptionCompletedAt !== null;
  const isReady = requirement === 'media' ? isMediaReady : isTranscriptionReady;

  if (!isReady) {
    return (
      <FragmentDisabledTabContent
        message={requirement === 'media' ? mediaNotReadyTooltip : transcriptionNotReadyTooltip}
      />
    );
  }

  return <>{children}</>;
}
